//import axios from "axios";
import React from "react";
import { MdAutoDelete } from "react-icons/md";
//import { toast } from "react-toastify";
import { Deleteall } from "../../Api/Offers/Offers";
import { useDispatch } from "react-redux";
import { Deletepartner } from "../../Api/UserManagement/Partner";
import { Deletepermission } from "../../Api/Role&Responsibilites/ActivePermission";
import { Tooltip } from "antd";
import { DeleteClient } from "../../Api/UserManagement/Client";

export default function DeleteList({
  content,
  title,
  setDeleteModalIsOpen,
  api,
  module,
  filter,
  setPermission,
  CurrentTab,
  listType
}) {
  // const DeletePromoData = async () => {
  //   const response = await axios.delete(api);
  //   toast.success(response?.data?.message);
  //   setDeleteModalIsOpen(false)
  // };
  const dispatch = useDispatch();
  const handlesubmit = () => {
    setDeleteModalIsOpen(false);
    if(module==="partner"){
      Deletepartner(api,dispatch,module);
    }else if(module==="permissions"){
      Deletepermission(api,filter,dispatch,setPermission)
    }else if(module==="client"){
      DeleteClient(api,dispatch,module);
    }
    else{ 
    Deleteall(api, dispatch, module, filter, setPermission, CurrentTab,listType);
    }
  };
  return (
    <div>
      <div className="flex flex-col  justify-center">
        <div className="items-center flex-col flex justify-center mt-[0.5vw]">
          <MdAutoDelete color="#1f4b7f" size={"5vw"} />
          <p className="text-[1.7vw] font-semibold text-[#1f4b7f] mt-[1vw]">
            Are You Sure ?
          </p>
          
<p className="flex justify-center items-center gap-[0.5vw] text-[1.1vw] text-[#1f4b7f] mt-[0.5vw] text-center leading-tight">
  <span>{content}</span>
  {title ? (
    title.length >= 20 ? (
      <Tooltip
        placement="top"
        title={title}
        className="cursor-pointer"
        color="white"
        overlayInnerStyle={{
          color: "#1F487C",
        }}
      >
        <span>{`${title.slice(0, 10)}...`}</span>
      </Tooltip>
    ) : (
      <span>{title}</span>
    )
  ) : (
    "-"
  )}?
</p>

        </div>
        <div className="flex items-center mt-[2vw] gap-[2vw] justify-center">
          <button
            className="border-[#1f4b7f] border-[0.1vw] rounded-[0.5vw] text-[1.1vw] font-semibold text-[#1f4b7f] w-[10vw]  h-[3vw]"
            onClick={() => setDeleteModalIsOpen(false)}
          >
            No
          </button>
          <button
            className="bg-[#1f4b7f] text-white font-semibold text-[1.1vw] w-[10vw] h-[3vw] rounded-[0.5vw]"
            // onClick={() => DeletePromoData()}
            onClick={() => handlesubmit()}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
}
